import { initializeApp } from "firebase/app"
import { getAuth } from "firebase/auth"

const _firebaseConfig = {
  apiKey: import.meta.env.PUBLIC_FIREBASE_API_KEY,
  authDomain: import.meta.env.PUBLIC_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.PUBLIC_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.PUBLIC_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.PUBLIC_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.PUBLIC_FIREBASE_APP_ID,
}

// TODO: Fix ENV vars
const firebaseConfig = {
  apiKey: "AIzaSyA-BwkktE9XnSk1o2wOesEFfXFA1TYdBxo",
  authDomain: "doktor-online-dev.firebaseapp.com",
  projectId: "doktor-online-dev",
  storageBucket: "doktor-online-dev.firebasestorage.app",
  messagingSenderId: "563412385821",
  appId: "1:563412385821:web:b62e8ef836794138c086f4",
  measurementId: "G-YMPWK91GS1",
}

const app = initializeApp(firebaseConfig)

const auth = getAuth(app)

export { auth }
